import React, { useEffect, useMemo } from "react";
import "./css/footer.css";
import contact from "../../data/layouts/contact";
import { Link } from "react-router-dom";

const Footer = ({
  nameCompany,
  contactItems = [],
  combinedData = [],
  infoFooter = [],
}) => {
  useEffect(() => {
    window.FB?.XFBML?.parse?.();
  }, []);

  const policyItems = useMemo(() => {
    if (!Array.isArray(infoFooter)) return [];
    return infoFooter.filter((i) => i?.key === "policy");
  }, [infoFooter]);

  const mapItem = useMemo(() => {
    if (!Array.isArray(infoFooter)) return null;
    return infoFooter.find((i) => i?.key === "map") || null;
  }, [infoFooter]);

  return (
    <footer className="footer">
      <div
        className="layer"
        data-bg="url(/images/statistics.webp)"
        style={{
          backgroundImage: 'url("/images/wavy-curve.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          {/* ROW 1: LOGO (riêng 1 hàng) */}
          <div className="row">
            <div className="col-12 position-relative">
              <Link className="logo" to="/" title={nameCompany?.value}>
                <img
                  src={contact.logo}
                  alt={nameCompany?.value}
                  loading="lazy"
                />
              </Link>
            </div>
          </div>

          {/* ROW 2: 3 cột ngang nhau: Liên hệ - Chính sách - Map */}
          <div className="row align-items-stretch justify-content-between mt-3">
            {/* COL 1: Thông tin liên hệ */}
            <div className="col-lg-5 col-md-7 d-flex">
              <div className="w-100 d-flex flex-column">
                <h3>Thông tin liên hệ</h3>

                <div className="flex-grow-0">
                  {contactItems?.map((item, index) => (
                    <div className="text-white mb-3" key={index}>
                      <img
                        src={`/images/icons/${item?.icon}`}
                        alt={item?.data?.title || "icon"}
                        style={{
                          width: "20px",
                          maxHeight: "24px",
                          marginRight: "8px",
                          verticalAlign: "middle",
                        }}
                        loading="lazy"
                      />
                      {item?.data?.value}
                    </div>
                  ))}
                </div>

                <div className="social-networks mt-auto mb-md-0">
                  {combinedData?.map(
                    (network, index) =>
                      network?.iconWhite && (
                        <Link
                          key={index}
                          className="me-2 me-sm-2"
                          to={network?.url}
                          title={network?.name}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={network.iconWhite}
                            alt={network?.name}
                            className="icon"
                            loading="lazy"
                          />
                        </Link>
                      )
                  )}
                </div>
              </div>
            </div>

            {/* COL 2: Chính sách */}
            <div className="col-lg-3 col-md-5 d-flex mt-4 mt-md-0">
              <div className="w-100 d-flex flex-column">
                <h3>Chính sách</h3>

                {policyItems?.length ? (
                  <ul
                    style={{
                      listStyle: "none",
                      paddingLeft: 0,
                      marginBottom: 0,
                    }}
                    className="flex-grow-1"
                  >
                    {policyItems.map((item, index) => (
                      <li key={index} className="mb-3">
                        <Link
                          className="link-policy"
                          to={`${item?.url || "#"}`}
                          title={item?.title}
                          style={{ display: "inline-block", lineHeight: 1.4 }}
                        >
                          {item?.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-white mb-0">Chưa có chính sách.</p>
                )}
              </div>
            </div>

            {/* COL 3: Map (rộng, cao đủ) */}
            <div className="col-lg-4 col-md-12 d-flex mt-4 mt-lg-0">
              <div className="w-100 d-flex flex-column">
                <div
                  style={{
                    width: "100%",
                    flexGrow: 1,
                    minHeight: 260, // đủ cao
                    borderRadius: "10px",
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.06)",
                  }}
                >
                  {mapItem?.url ? (
                    <iframe
                      src={mapItem.url}
                      title="Bản đồ"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: 260,
                        border: "none",
                        display: "block",
                      }}
                    />
                  ) : (
                    <div
                      className="text-white"
                      style={{
                        height: "100%",
                        minHeight: 260,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 14,
                        textAlign: "center",
                      }}
                    >
                      Chưa có bản đồ.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* DÒNG DƯỚI CÙNG: GIỮ NGUYÊN, KHÔNG ĐỤNG */}
          <div className="copyright">
            <p className="p-0 text-end sub-footer">
              Design by{" "}
              <Link
                to="https://katec.vn"
                title="katec.vn"
                className="text-white fw-bold"
                target="_blank"
              >
                Katec.vn
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
